export const FRONT_PAGE_MODULES = {
  // DefaultIndexPage modules (joszaki, superprofik-cz, berufexperten-de)
  "hero": () =>
    import("~/components/_refactored/indexPage/front-page-modules/HeroModule.vue"),
  "offer-or-search": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/OfferOrSearchModule.vue"
    ),
  "registration-cta": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/RegistrationCtaModule.vue"
    ),
  "partner-logos": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/PartnerLogosModule.vue"
    ),
  "reviews": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/ReviewsModule.vue"
    ),
  "popular-professions": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/PopularProfessionsModule.vue"
    ),
  "experts-near-you": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/ExpertsNearYouModule.vue"
    ),
  "how-it-works": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/HowItWorksModule.vue"
    ),
  "job-tips": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/JobTipsModule.vue"
    ),
  "profession-groups": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/ProfessionGroupsModule.vue"
    ),
  "faq": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/FaqModule.vue"
    ),
  "blog": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/BlogModule.vue"
    ),
  "cta-banner": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/CtaBannerModule.vue"
    ),
  "rich-text": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/RichTextModule.vue"
    ),

  // PriceOfferIndexPage modules (price-offer-creator)
  "price-offer-hero": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/PriceOfferHeroModule.vue"
    ),
  "price-offer-info-boxes": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/PriceOfferInfoBoxesModule.vue"
    ),
  "price-offer-pricing": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/PriceOfferPricingModule.vue"
    ),
  "price-offer-stats": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/PriceOfferStatsModule.vue"
    ),
  "price-offer-testimonials": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/PriceOfferTestimonialsModule.vue"
    ),
  "price-offer-faq": () =>
    import(
      "~/components/_refactored/indexPage/front-page-modules/PriceOfferFaqModule.vue"
    ),
};

/**
 * Slugs that can appear more than once on the front page.
 * All other slugs are limited to a single instance.
 * Instances are stored with suffixed slugs: rich-text, rich-text-2, rich-text-3, etc.
 */
export const MULTI_INSTANCE_SLUGS = new Set(["rich-text"]);

/**
 * Returns the base slug for multi-instance modules.
 * e.g. "rich-text-2" → "rich-text", "hero" → "hero"
 */
export const getBaseSlug = (slug) => {
  if (MULTI_INSTANCE_SLUGS.has(slug)) return slug;
  const match = slug.match(/^(.+)-(\d+)$/);
  if (match && MULTI_INSTANCE_SLUGS.has(match[1])) return match[1];
  return slug;
};

// Fallback configs if API is unreachable (also used as seed data for initial DB migration)
export const DEFAULT_MODULE_CONFIGS = {
  joszaki: [
    {
      slug: "hero",
      label: "Hero Section",
      position: 0,
      row: 0,
      isVisible: true,
    },
    {
      slug: "offer-or-search",
      label: "Offer or Search",
      position: 1,
      row: 1,
      isVisible: true,
    },
    {
      slug: "reviews",
      label: "Vélemények",
      position: 2,
      row: 2,
      isVisible: true,
    },
    {
      slug: "partner-logos",
      label: "Partner logók",
      position: 3,
      row: 3,
      isVisible: true,
    },
    {
      slug: "registration-cta",
      label: "Registration CTA",
      position: 4,
      row: 4,
      isVisible: true,
    },
  ],
  "superprofik-cz": [
    {
      slug: "hero",
      label: "Hero Section",
      position: 0,
      row: 0,
      isVisible: true,
    },
    {
      slug: "offer-or-search",
      label: "Offer or Search",
      position: 1,
      row: 1,
      isVisible: true,
    },
    {
      slug: "reviews",
      label: "Reviews",
      position: 2,
      row: 2,
      isVisible: true,
    },
    {
      slug: "partner-logos",
      label: "Partner Logos",
      position: 3,
      row: 3,
      isVisible: true,
    },
    {
      slug: "registration-cta",
      label: "Registration CTA",
      position: 4,
      row: 4,
      isVisible: true,
    },
  ],
  "berufexperten-de": [
    {
      slug: "hero",
      label: "Hero Section",
      position: 0,
      row: 0,
      isVisible: true,
    },
    {
      slug: "offer-or-search",
      label: "Offer or Search",
      position: 1,
      row: 1,
      isVisible: true,
    },
    {
      slug: "reviews",
      label: "Reviews",
      position: 2,
      row: 2,
      isVisible: true,
    },
    {
      slug: "partner-logos",
      label: "Partner Logos",
      position: 3,
      row: 3,
      isVisible: true,
    },
    {
      slug: "registration-cta",
      label: "Registration CTA",
      position: 4,
      row: 4,
      isVisible: true,
    },
  ],
  "price-offer-creator": [
    {
      slug: "price-offer-hero",
      label: "Hero Section",
      position: 0,
      row: 0,
      isVisible: true,
    },
    {
      slug: "price-offer-info-boxes",
      label: "Info Boxes",
      position: 1,
      row: 1,
      isVisible: true,
    },
    {
      slug: "price-offer-pricing",
      label: "Pricing Cards",
      position: 2,
      row: 2,
      isVisible: true,
    },
    {
      slug: "price-offer-stats",
      label: "Statistics",
      position: 3,
      row: 3,
      isVisible: true,
    },
    {
      slug: "price-offer-testimonials",
      label: "Testimonials",
      position: 4,
      row: 4,
      isVisible: true,
    },
    {
      slug: "price-offer-faq",
      label: "FAQ",
      position: 5,
      row: 5,
      isVisible: true,
    },
  ],
};
